module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cLpci"))).then(() => parcelRequire('8rm4T'));